import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Get, Post, Delete } from "utils/axios";
import { requestError, requestSuccess } from "utils/requestHandler";

const HOC = (WrappedComponent) => {
	class WithHOC extends Component {
		state = {
			loading: false,
			selectedPostTags: [],
			tags: [],
		};

		onChangeTagsHOC = (key, val) => this.setState({ [key]: val });

		load = (param) => this.setState({ loading: param });

		getTag = () =>
			Get(`/mywheels/tags`, this.getTagSuccess, this.getTagError, this.load);
		getTagSuccess = (payload) => {
			let temp = _.map(payload.data, (tempChild) => ({
				value: tempChild.id,
				label: tempChild.name,
				...tempChild,
			}));

			this.setState({
				tags: temp,
			});
		};
		getTagError = (error) => requestError(error);

		createTag = (dataToSubmit, cb) => {
			Post(
				`/mywheels/tags`,
				dataToSubmit,
				(payload) => this.createTagSuccess(payload, cb),
				this.createTagError,
				this.load
			);
		};
		createTagSuccess = (payload, cb) => {
			this.getTag();
			cb({
				...payload.data,
				value: payload.data.id,
				label: payload.data.name,
			});
			requestSuccess("Record created successfully.");
		};
		createTagError = (error) => requestError(error);

		getPostTags = (id) =>
			Get(
				`/mywheels/tags-posts?post_id=${id}`,
				this.getPostTagsSuccess,
				this.getPostTagsError,
				this.load
			);
		getPostTagsSuccess = (payload) => {
			this.setState({
				selectedPostTags: payload.data,
			});
		};
		getPostTagsError = (error) => requestError(error);

		addPostTag = (postId, tagID) =>
			Post(
				`/mywheels/tags-posts`,
				{
					mywheels_tag_id: tagID,
					post_id: postId,
				},
				() => this.addPostTagSuccess(postId),
				this.addPostTagError,
				this.load
			);
		addPostTagSuccess = (postId) => {
			this.getPostTags(postId);
			requestSuccess("Record created successfully.");
		};
		addPostTagError = (error) => requestError(error);

		deletePostTag = (id, postId) =>
			Delete(
				`/mywheels/tags-posts/${id}`,
				() => this.deletePostTagSuccess(postId),
				this.deletePostTagError,
				this.load
			);
		deletePostTagSuccess = (postId) => {
			this.getPostTags(postId);
			requestSuccess("Record deleted successfully.");
		};
		deletePostTagError = (error) => requestError(error);

		render = () => {
			return (
				<WrappedComponent
					{...this.props}
					selectedPostTags={this.state.selectedPostTags}
					tags={this.state.tags}
					onLoadTags={this.state.loading}
					getTag={this.getTag}
					getSelectedTag={this.getSelectedTag}
					createTag={this.createTag}
					getPostTags={this.getPostTags}
					deletePostTag={this.deletePostTag}
					addPostTag={this.addPostTag}
					onChangeTagsHOC={this.onChangeTagsHOC}
				/>
			);
		};
	}
	const mapStateToProps = (state) => ({ data: state });
	return connect(mapStateToProps)(WithHOC);
};

export default HOC;
